import { localize, setLocale } from '@vee-validate/i18n'
import de from '@vee-validate/i18n/dist/locale/de.json'
import en from '@vee-validate/i18n/dist/locale/en.json'
import { confirmed, email, min, regex, required } from '@vee-validate/rules'
import { configure, defineRule } from 'vee-validate'

export default function useValidation() {
  const { locale } = useL10n()

  configure({
    generateMessage: localize({ de, en })
  })

  setLocale(locale.value)

  defineRule('confirmed', confirmed)
  defineRule('email', email)
  defineRule('min', min)
  defineRule('regex', regex)
  defineRule('required', required)
}
